import { render } from "./identification.vue?vue&type=template&id=6ba713e4&scoped=true"
import script from "./identification.vue?vue&type=script&lang=js"
export * from "./identification.vue?vue&type=script&lang=js"

import "./identification.vue?vue&type=style&index=0&id=6ba713e4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba713e4"]])

export default __exports__